<template>
  <div class="base case" style="">
    <div>
      <inside-header title="我的推广" />
    </div>
    <a-alert v-if="!loading && !promote_enable" message="后台未设置推广计划" :description="
      '佣金：用户/教员注册并实名认证可获取' +
      config.promote_realname_commission +
      '元佣金，教员通过审核可获得' +
      config.promote_apply_teacher_commission +
      '元佣金。'
    " type="info" />
    <div v-else-if="!loading && !realname_status">
      <a-alert message="需要实名认证才能申请成为推广大使" :description="
        '佣金：用户/教员注册并实名认证可获取' +
        config.promote_realname_commission +
        '元佣金，教员通过审核可获得' +
        config.promote_apply_teacher_commission +
        '元佣金。'
      " type="warning" />
      <div style="margin-top: 10px;">
        <a-button size="large" type="primary" block @click="goRealname">
          去实名
        </a-button>
      </div>
    </div>
    <!-- 申请成为推广大使 -->
    <div v-else-if="!loading && !account_promote_status">
      <a-alert message="您还未申请成为推广大使" :description="
        '佣金：用户/教员注册并实名认证可获取' +
        config.promote_realname_commission +
        '元佣金，教员通过审核可获得' +
        config.promote_apply_teacher_commission +
        '元佣金。'
      " type="info" />
      <div style="margin-top: 10px;">
        <a-button size="large" type="primary" block @click="showApplyDrawer">
          立即申请
        </a-button>
      </div>
      <!-- 申请抽屉 -->
      <a-drawer title="成为推广大使" placement="bottom" :closable="false" :height="500" :visible="visibleApplyDrawer"
        :body-style="{ padding: '50px', paddingBottom: '80px' }" @close="onClosevisibleApplyDrawer">
        <a-alert message="您好，您正在申请成为推广大使。请将您申请的原因填写到表单中" banner />
        <a-form :form="applyForm" style="margin-top: 40px;" @submit="handleApplysubmit">
          <a-form-item>
            <a-textarea v-decorator="[
              'reason',
              {
                rules: [
                  { required: true, message: '请输入申请原因' },
                  { min: 10, message: '至少输入10个汉字' }
                ]
              }
            ]" :rows="4" placeholder="请输入申请的原因" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" :loading="state.applyBtn" html-type="submit" block>
              提交
            </a-button>
          </a-form-item>
        </a-form>
      </a-drawer>
    </div>
    <div v-else>
      <div class="info" style="">
        <div><span>可提现</span></div>
        <div class="wape" style="">
          <span style="">{{
              promoter_info.earned_income - promoter_info.cash_withdrawn
          }}</span>
          <button style="" @click="goWithdraw">
            提现
          </button>
        </div>
        <div class="node" style="">
          <a-row>
            <a-col :span="8">
              <div class="login" style="">
                <div>注册数量</div>
                <div>{{ promoter_info.register_count }}</div>
              </div>
            </a-col>
            <a-col :span="8" class="teacher" style="">
              <div>通过教员</div>
              <div>{{ promoter_info.apply_pass_count }}</div>
            </a-col>
            <a-col :span="8">
              <div class="get" style="">
                <div>已获收益</div>
                <div>{{ promoter_info.earned_income }}</div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="switch">
        <a-row :gutter="8">
          <a-col :span="9">
            <div class="bar" style="">
              <a-progress v-if="!loading" type="dashboard" :percent="
                Math.ceil(
                  (data.total_earned_income * 100) / config.promote_amount
                )
              " :width="99" :gap-degree="110" :stroke-color="{ '0%': '#ff5c00', '100%': '#fdd5b6' }" />
            </div>
          </a-col>
          <a-col :span="15">
            <div class="tail" style="">
              <span>{{ config.promote_name }}</span>
            </div>
            <div class="air" style="">
              <span>{{ config.promote_desc }}</span>
            </div>
          </a-col>
        </a-row>
      </div>
      <div class="wafo" style="">
        <a-row>
          <a-col :span="8">
            <span class="kast" style="">专属推广码</span>
          </a-col>
          <a-col :span="10">
            <span id="promote_code" class="unil" style="">{{
                promoter_info.referral_code
            }}</span>
          </a-col>
          <a-col :span="6" class="load" style="">
            <button style="" class="copyElePromote" data-clipboard-target="#promote_code">
              复制
            </button>
          </a-col>
        </a-row>
      </div>
      <div class="wafo" style="">
        <a-row>
          <a-col :span="8">
            <span class="kast" style="">用户注册链接</span>
          </a-col>
          <a-col :span="10" style="word-break:break-all;">
            <span v-if="!loading" class="unil">{{ PromoteList.user_register_link.slice(0, 15) }}...</span>
            <span id="user_register_link" style="display:none;">{{
                PromoteList.user_register_link
            }}</span>
          </a-col>
          <a-col :span="6" class="load">
            <button class="copyEleUserLink" data-clipboard-target="#user_register_link">
              复制
            </button>
          </a-col>
        </a-row>
      </div>
      <div class="wafo">
        <a-row>
          <a-col :span="8">
            <span class="kast">教员注册链接</span>
          </a-col>
          <a-col :span="10" style="word-break:break-all;">
            <span v-if="!loading" class="unil">{{ PromoteList.teacher_register_link.slice(0, 15) }}...</span>
            <span id="teacher_register_link" style="display:none;">{{
                PromoteList.teacher_register_link
            }}</span>
          </a-col>
          <a-col :span="6" class="load">
            <button class="copyEleTeacherLink" data-clipboard-target="#teacher_register_link">
              复制
            </button>
          </a-col>
        </a-row>
      </div>
      <div style="height:56px;margin-top:18px;">
        <van-cell title="提现记录" is-link @click="goDrawal" />
      </div>
      <div style="height:56px;">
        <van-cell title="收益明细" is-link @click="goEarnings" />
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { InsideHeader, MainFooter } from '@/components'
import ClipboardJS from 'clipboard'
export default {
  name: 'UserPromotion',
  components: {
    InsideHeader,
    MainFooter
  },
  data() {
    return {
      loading: true,
      state: {
        applyBtn: false
      },
      data: [],
      PromoteList: [],
      promoter_info: [],
      // 申请表单相关
      applyForm: this.$form.createForm(this, 'apply-form'),
      visibleApplyDrawer: false,
      // 系统是否开启推广
      promote_enable: false,
      // 用户实名状态
      realname_status: false,
      // 用户推广状态，是否启用
      account_promote_status: false,
      config: [],
      past: 0
    }
  },
  created() {
    this.loadData()
  },
  mounted() {
    const _this = this
    var clipboard2 = new ClipboardJS('.copyElePromote', {
      text: function () {
        return document.getElementById('promote_code').innerHTML
      }
    })
    clipboard2.on('success', function (e) {
      _this.$message.success('复制成功')
      e.clearSelection()
    })
    clipboard2.on('error', function () {
      _this.$message.error('复制失败')
    })

    var clipboard3 = new ClipboardJS('.copyEleUserLink', {
      text: function () {
        return document.getElementById('user_register_link').innerHTML
      }
    })
    clipboard3.on('success', function (e) {
      _this.$message.success('复制成功')
      e.clearSelection()
    })
    clipboard3.on('error', function () {
      _this.$message.error('复制失败')
    })

    var clipboard4 = new ClipboardJS('.copyEleTeacherLink', {
      text: function () {
        return document.getElementById('teacher_register_link').innerHTML
      }
    })
    clipboard4.on('success', function (e) {
      _this.$message.success('复制成功')
      e.clearSelection()
    })
    clipboard4.on('error', function () {
      _this.$message.error('复制失败')
    })
  },
  //   mounted () {
  //     const _this = this
  //     const ClipboardJSObj = new ClipboardJS('.copyEle')// className中有copyEle的元素
  //     // 定义复制成功回调
  //     ClipboardJSObj.on('success', function (e) {
  //       _this.$message.success('复制成功')
  //       e.clearSelection()
  //     })
  //     // 定义复制失败回调
  //     ClipboardJSObj.on('error', function (e) {
  //       _this.$message.error('复制失败')
  //     })
  //   },
  methods: {
    loadData() {
      this.loading = true
      this.$http({
        url: 'index/promote/relevant',
        method: 'get'
      }).then(res => {
        console.log(res)
        this.loading = false
        if (res.status === 'success') {
          var data = res.data
          console.log(data)
          this.data = res.data
          this.PromoteList = data
          this.promoter_info = data.promoter_info
          this.promote_enable = data.promote_enable
          this.realname_status = data.realname_status
          this.config = data.config
          this.account_promote_status = data.account_promote_status
        } else {
          this.$toast.fail('系统繁忙,请刷新重试')
        }
      })
    },
    goWithdraw() {
      this.$router.push({ name: 'UserPromoteWithDrawal' })
    },
    goDrawal() {
      this.$router.push({ name: 'UserPromoteWithdrawalRecord' })
    },
    goEarnings() {
      this.$router.push({ name: 'UserPromoteReturnsDetailed' })
    },
    // 展示申请框
    showApplyDrawer() {
      this.visibleApplyDrawer = true
    },
    goRealname() {
      this.$router.push({ name: 'UserSettingRealname' })
    },
    // 提交申请
    handleApplysubmit(e) {
      console.log('提交')
      e.preventDefault()
      this.applyForm.validateFields((err, values) => {
        if (!err) {
          this.state.applyBtn = true
          this.$http({
            url: '/index/promote/apply',
            method: 'post',
            data: values
          }).then(res => {
            this.state.applyBtn = false
            if (res.status === 'success') {
              this.$toast.success('申请提交成功')
              this.visibleApplyDrawer = false
              this.loadData()
            } else {
              this.$toast.fail(res.message)
            }
          })
        }
      })
    },
    // 关闭申请框
    onClosevisibleApplyDrawer() {
      this.visibleApplyDrawer = false
    }
  }
}
</script>
<style lang="stylus" scoped>
.case {
    padding:15px;
    min-width: 280px;
    max-width: 420px;
    .info {
        margin-top:27px;
        width: 100%;
        height: 159px;
        background-color:#ffffff;
        border-radius: 10px;
        box-shadow: 0 0 10px inset rgba(216,216,216,0.3);
        padding: 20px 15px;
        .wape {
            overflow:hidden;
            span {
                    line-height:28px;
                    color:#333333;
                    padding-left:15px;
                }
            button {
                float:right;
                text-align:center;
                border-radius: 15px;
                background-color: #fa750d;
                width: 75px;
                height: 31px;
                border:none;
                color:#ffffff;
                font-size:14px;
            }
        }
        .node {
                margin-top:31px;
                .login {
                    width:58px;
                    text-align:center;
                }
                .teacher {
                    text-align:center;
                }
                .get {
                    float:right;
                    text-align:center;
                }
        }
    }
    .switch {
        width: 100%;
        margin-top:15px;
        background-color: #ffffff;
        border-radius: 10px;
        box-shadow: 0 0 10px inset rgba(216,216,216,0.3);
        .bar {
            padding-left:16px;
            padding-top:20px;
        }
        .tail {
            padding-top:20px;
            font-size:16px;
            color:#333333;
            height:16px;
        }
        .air {
            margin-top:35px;
            font-size:14px;
            height:31px;
            color:#666666;
            padding-right:23px;
        }
    }
    .wafo {
        margin-top:15px;
        padding-left:15px;
        width:100%;
        border-radius:10px;
        box-shadow: 0 0 10px inset rgba(216,216,216,0.3);
        .kast {
            line-height:50px;color:#999999;
        }
        .unil {
            padding-left:11px;
            line-height:50px;
            color:#333333;
        }
        .load {
            text-align:right;
            button {
                width:79px;
                height:50px;
                background-color:#fa750d;
                border-radius:10px;
                border:none;
                color:#ffffff;
            }
        }
    }
}
</style>
